import { createAction, props } from '@ngrx/store';

export const ReasonCodes = '[reason codes] load reason codes';
export const ReasonCodesSuccess =
  '[ReasonCodesSuccess] load reason code success';
export const LoadProducts = '[loadProducts] load products';
export const LoadProductSuccess = '[loadProductSuccess] load products success';
export const LoadProductTotalCount =
  '[LoadProductTotalCount] load products total count';
export const ValidateStockCorrection =
  '[ValidateStockCorrection] validate stock correction';
export const ValidateStockCorrectionSuccess =
  '[ValidateStockCorrectionSuccess] validate stock correction success';
export const CorrectStockCorrection =
  '[CorrectStockCorrection] correct stock correction';
export const CorrectStockCorrectionSuccess =
  '[CorrectStockCorrectionSuccess] correct stock correction success';
export const ImportStockCorrection =
  '[ImportStockCorrection] import stock correction';
export const ImportStockCorrectionSuccess =
  '[ImportStockCorrectionSuccess] import stock correction success';
export const LoadProductsForExport =
  '[LoadProductsForExport] load stock correction products for export';
export const ExportStockCorrection =
  '[ExportStockCorrection] import stock correction';
export const ExportStockCorrectionSuccess =
  '[ExportStockCorrectionSuccess] import stock correction success';
export const LoadPiLocations = '[LoadPiLocations] load pi locations';
export const LoadPiLocationsSuccess =
  '[LoadPiLocationsSuccess] load pi location success';
export const LoadPiProducts = '[LoadPiProducts] load pi products';
export const LoadPiProductsSuccess =
  '[LoadPiProductsSuccess] load pi poroducts success';
export const ExportPiCount = '[ExportPiCount] import pi count';
export const ExportPiCountSuccess =
  '[ExportPiCountSuccess] import pi count success';
export const ImportPiCount = '[ImportPiCount] import pi count';
export const ImportPiCountSuccess =
  '[ImportPiCountSuccess] import pi count success';
export const CancelPiCount = '[CancelPiCount] cancel pi count';
export const CancelPiCountSuccess =
  '[CancelPiCountSuccess] cancel pi count success';
export const StartPiCount = '[StartPiCount] cancel pi count';
export const StartPiCountSuccess =
  '[StartPiCountSuccess] cancel pi count success';
export const SavePiCount = '[SavePiCount] save pi count';
export const SavePiCountSuccess = '[SavePiCountSuccess] save pi count success';
export const CompletePiCount = '[CompletePiCount] complete pi count';
export const CompletePiCountSuccess =
  '[CompletePiCountSuccess] complete pi count success';

export const GetAllPiLocations =
  '[GetAllPiLocations] get all pi locations count';
export const GetAllPiLocationsSuccess =
  '[GetAllPiLocationsSuccess] get all pi locations success';
export const AddPiLocation = '[AddPiLocation] add pi locations';
export const AddPiLocationsSuccess =
  '[AddPiLocationsSuccess]add pi locations success';
export const EditPiLocation = '[EditPiLocation] add pi locations';
export const EditPiLocationsSuccess =
  '[EditPiLocationsSuccess]add pi locations success';

export const loadReasonCodes = createAction(ReasonCodes);
export const loadReasonCodesSuccess = createAction(
  ReasonCodesSuccess,
  props<{ reasonCodes: any; reasonCodeFilter: any }>()
);

export const loadProducts = createAction(
  LoadProducts,
  props<{
    offset: number;
    limit: number;
    description: any;
    sortBy?: Array<any>;
    filterOpts?: object;
  }>()
);

export const loadProductSuccess = createAction(
  LoadProductSuccess,
  props<{ products: any }>()
);
export const loadProductTotalCount = createAction(
  LoadProductTotalCount,
  props<{ totalCount: any }>()
);

export const validateStockCorrection = createAction(
  ValidateStockCorrection,
  props<{ dataSend: any }>()
);
export const validateStockCorrectionSuccess = createAction(
  ValidateStockCorrectionSuccess,
  props<{ status: any; message: any }>()
);
export const correctStockCorrection = createAction(
  CorrectStockCorrection,
  props<{ status: any; message: any }>()
);
export const correctStockCorrectionSuccess = createAction(
  CorrectStockCorrectionSuccess,
  props<{ status: any; message: any }>()
);
export const importStockCorrection = createAction(
  ImportStockCorrection,
  props<{ file: any }>()
);
export const importStockCorrectionSuccess = createAction(
  ImportStockCorrectionSuccess,
  props<{ status: any; products: any }>()
);
export const exportStockCorrection = createAction(
  ExportStockCorrection,
  props<{ products: any; reasonCodeSelection: any; userSelection: any }>()
);
export const exportStockCorrectionSuccess = createAction(
  ExportStockCorrectionSuccess
);
export const loadProductsForExport = createAction(
  LoadProductsForExport,
  props<{ reasonCodeSelection: any; userSelection: any }>()
);

export const loadPiLocations = createAction(LoadPiLocations);
export const loadPiLocationsSuccess = createAction(
  LoadPiLocationsSuccess,
  props<{ piLocations: any }>()
);
export const loadPiProducts = createAction(
  LoadPiProducts,
  props<{
    isPiStarted: boolean;
    piCountId: string;
    offset: number;
    limit: number;
    sortBy?: Array<any>;
    filterOpts?: object;
  }>()
);
export const loadPiProductsSuccess = createAction(
  LoadPiProductsSuccess,
  props<{
    piProducts: any;
    totalCount: any;
  }>()
);
export const exportPiCount = createAction(
  ExportPiCount,
  props<{ piCountId: any }>()
);
export const exportPiCountSuccess = createAction(ExportPiCountSuccess);
export const importPiCount = createAction(
  ImportPiCount,
  props<{ piCountId: any; file: any }>()
);
export const importPiCountSuccess = createAction(
  ImportPiCountSuccess,
  props<{ products: any }>()
);
export const cancelPiCount = createAction(
  CancelPiCount,
  props<{ piCountId: any }>()
);
export const cancelPiCountSuccess = createAction(
  CancelPiCountSuccess,
  props<{ status: boolean; message: any }>()
);
export const startPiCount = createAction(
  StartPiCount,
  props<{ piCountId: any }>()
);
export const startPiCountSuccess = createAction(
  StartPiCountSuccess,
  props<{ status: boolean; message: any }>()
);
export const savePiCount = createAction(
  SavePiCount,
  props<{ piCountId: any; saveData: any }>()
);
export const savePiCountSuccess = createAction(
  SavePiCountSuccess,
  props<{ status: boolean; message: any }>()
);
export const completePiCount = createAction(
  CompletePiCount,
  props<{ piCountId: any; completeData: any }>()
);
export const completePiCountSuccess = createAction(
  CompletePiCountSuccess,
  props<{ status: boolean; message: any }>()
);
export const getAllPiLocations = createAction(GetAllPiLocations);
export const getAllPiLocationsSuccess = createAction(
  GetAllPiLocationsSuccess,
  props<{ locations: any }>()
);
export const addPiLocation = createAction(
  AddPiLocation,
  props<{
    piName: any;
    arrayOfLocations: any;
  }>()
);
export const addPiLocationsSuccess = createAction(
  AddPiLocationsSuccess,
  props<{ status: any }>()
);
export const editPiLocation = createAction(
  EditPiLocation,
  props<{
    piName: any;
    dataKey: any;
    arrayOfLocations: any;
  }>()
);
export const editPiLocationsSuccess = createAction(
  EditPiLocationsSuccess,
  props<{ status: any }>()
);
